const AssignedEmployeeVisibleColumn = [
    {
        title: "Employee No",
        field: "EmployeeNo",
        locked: false,
        filter: "numeric",
        customFilterType: 'CustomNumericText',
        width: "170",
        show: true,
    },
    {
        title: "Employee Name",
        field: "EmployeeName",
        locked: false,
        filter: "text",
        width: "190",
        show: true,
    },
    {
        title: "Department Name",
        field: "DepartmentName",
        locked: false,
        filter: "text",
        width: "270",
        show: true,
    },
    {
        title: "Position Name",
        field: "PositionName",
        locked: false,
        filter: "text",
        width: "270",
        show: true,
    },
    {
        title: "Assigned supervisor",
        field: "supervisorsName",
        locked: false,
        filter: "text",
        width: "270",
        show: true,
    },
    {
        title: "Employee Status",
        field: "ActiveStatus",
        locked: false,
        filter: "numeric",
        width: "210",
        show: true,
    },
    {
        title: "Active Date",
        field: "ActiveDate",
        locked: false,
        filter: "date",
        format: "MM/DD/yyyy",
        editor: "date",
        width: "210",
        show: true,
    },
    {
        title: "End Date",
        field: "EndDate",
        locked: false,
        filter: "date",
        format: "MM/DD/yyyy",
        editor: "date",
        width: "210",
        show: true,
    }
];

export default AssignedEmployeeVisibleColumn;
